import { useRef, useEffect, useCallback } from "react";

function useClickOutside<T extends HTMLElement = HTMLDivElement>(
  handler: () => void,
  enabled: boolean = true,
  extraRef?: React.RefObject<HTMLElement>
) {
  const ref = useRef<T>(null);

  const stableHandler = useCallback(handler, [handler]);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      if (
        ref.current &&
        !ref.current.contains(target) &&
        (!extraRef || !extraRef.current?.contains(target))
      ) {
        stableHandler();
      } else {
        console.log("Click is inside, keeping dropdown open");
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 100);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [stableHandler, enabled, extraRef]); 
  return ref;
}

export default useClickOutside;
